

















import { defineComponent } from "@vue/composition-api";
import NoteModel from "@/ts/models/noteClass";
import CloseDialog from "@c/atoms/app/CloseDialog.vue";

export default defineComponent({
  name: "NotePopup",

  props: {
    note: {
      type: Object as () => NoteModel
    }
  },

  components: {
    CloseDialog
  },

  setup() {
    return {};
  }
});
